import { useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useMenuNavigationStyles } from '../menuStyles/menuNavigationStyles';
import HeaderEnum from '../topLevelMenu/headerEnum';
import { TopLevelMenu } from '../topLevelMenu/TopLevelMenu';

import { Account } from './Constants';

const HomeMenu: React.FC = () => {
  const theme = useTheme();
  const styles = useMenuNavigationStyles(theme);
  const navigate = useNavigate();

  const isHome = window.location.href.endsWith(window.location.host + '/');

  const handleClick = () => {
    navigate('/');
  };

  return (
    <TopLevelMenu
      alternateTitle={HeaderEnum.Home}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      className={`home-menu ${styles.root}`}
      hidden={isHome}
      href={Account[HeaderEnum.Home]}
      menuListClassName={`home-menu-list`}
      titleEnum={HeaderEnum.Home}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      onClick={handleClick}
    />
  );
};

export default HomeMenu;
